module.exports = "/_next/static/images/5e3ef50ceef5d160754d7969e92ed3a9-google-screen.png";